import { GET_DIST_POST_QUERY_DATA_SUCCESS } from "../types/support";

export function support(state = { supportQueries: [] }, action) {
  switch (action.type) {
    case GET_DIST_POST_QUERY_DATA_SUCCESS: {
      const { Dtinformation } = action.body;
      return { ...state, supportQueries: Dtinformation };
    }

    default:
      return state;
  }
}
